import React, {useState,useEffect} from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import Amplify, {Auth,Hub} from 'aws-amplify';
import awsmobile from '../../aws-exports';
import {UserData, CurrentState} from '../../context';
import Login from '../Login/Login';
import BackendConfig from '../../stacks/config/ConfigAWS'
import DisplayScreen from '../DisplayScreen/DisplayScreen'
import SearchScreen from '../SearchScreen/SearchScreen'
import InterestsScreen from '../InterestsScreen/InterestsScreen'
import AdminScreen from '../AdminScreen/AdminScreen'
import PortalRecentMessageScreen from '../PortalRecentMessageScreen/PortalRecentMessageScreen'
import DisclaimerScreen,{disclaimerVersion} from '../DisclaimerScreen/DisclaimerScreen'
import LoadingScreen from '../LoadingScreen/LoadingScreen'
import Progress from '../../stacks/progress/ProgressAWS';


Amplify.configure(awsmobile);

// var globalProgressesTimer = undefined //TODO should be in context perhaps

function getProductAbbrev(productName) {
  switch (productName) {
  case 'client': return 'dp'
  case 'dreamportal': return 'sof'
  default:
  }
  throw new Error('Login product unknown')
}

function getRegURL() {
  let regURL = undefined
  const deliveryBucketParts = awsmobile.aws_content_delivery_bucket.split('-')
  const productName = deliveryBucketParts[0]
  const product = getProductAbbrev(productName)
  const env = deliveryBucketParts.pop()
  switch (env) {
    case 'test': regURL = `https://signup-test.dreamexcloud.com?product=${product}`; break;
    case 'prod': regURL = `https://signup.dreamexcloud.com?product=${product}`; break;
    default: regURL = `http://localhost:3002?product=${product}`; break;
  }
  return regURL
}

function getUserNameFromURL() {
  const url = new URL(document.location)
  return url.searchParams.get('user-name') || ''
}

const App = () => {
  // const localConfig = JSON.parse(window.localStorage.getItem("dreamexportal") || "{}")
  const [user,setUser] = useState(null);
  const [currentState,setCurrentState] = useState({
    isAdmin: false,
    // eslint-disable-next-line
    initialURL: '/'
  });
  const [phoneVerifReq,setPhoneVerifReq] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(true)
  const [searchString, setSearchString] = useState('')

  const userName = getUserNameFromURL()
  
  const updateCurrentState = (value) => {
    const newState = {...currentState, ...value}
    setCurrentState(newState)
  }

  function resetInitialURL() {
    setCurrentState({...currentState, initialURL: '/'})
  }

  function updateSearchString(value) {
    setSearchString(value)
  }

  const regURL = getRegURL()


  useEffect(() => {

    async function getConfig() {
      try {
        const userData = await Auth.currentAuthenticatedUser({bypassCache: true});
        const payload = userData.signInUserSession
          && userData.signInUserSession.accessToken
          && userData.signInUserSession.accessToken.payload
        if (payload) {
          const groups = payload['cognito:groups']
          var isAdmin = groups && groups.includes('admin')
          var sub = payload['sub']
          setCurrentState({...currentState, isAdmin, sub})
        }
        const configAPI = BackendConfig.getInstance()

        const config = await configAPI.retrieve()

        if (isAdmin && config && config.progresses && config.progresses.interestCriteria !== 'completed') {
          const newState = {...currentState, isAdmin, sub, initialURL: '/interests'}
          setCurrentState(newState)
        }

        const agree = config && config.progresses && config.progresses.disclaimerAgree === disclaimerVersion
        const dontShow = config && config.progresses && config.progresses.disclaimerDontShowAgain === 'true'

        if (agree && dontShow) {
          setShowDisclaimer(false)
        }
        return config
      }
      catch (error) {
        console.error(`ERROR getConfig ${error.message}`)
        return {env: 'error'}
      }
    }
  
    async function getUserData() {
      const config = await getConfig()
      const userData = await Auth.currentAuthenticatedUser();
      let userState = null;
      if (userData) {
        userState = userData
        userState['config'] = config
      }
      setUser(userState);
    }
  
    function onHubCapsule(capsule) {
      switch(capsule.payload.event) {
        case 'signIn':
          getUserData();
          break;
        case 'signUp':
          getUserData();
          break;
        case 'signOut':
          setUser(null);
          break;
        default:
          return;
      }
    }
  
    getUserData();

    Hub.listen('auth', onHubCapsule);

    return () => {
      Hub.remove('auth', onHubCapsule);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    async function getUserData() {
      try {
        const userData = await Auth.currentAuthenticatedUser({bypassCache: true});
        setUser({...user, ...userData})
      } catch (err) {
        if (err !== 'not authenticated') {
          console.log(`getUserData in emailVerifReq ${err}`)
        }
      }
    }
    getUserData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneVerifReq])

  useEffect(() => {
    if (user && user.attributes) {
      if (!user.attributes.phone_number_verified) {
        setPhoneVerifReq(true);
      }
    }
  },[user])


  if (!user) {
    return <Login regURL={regURL} userName={userName}/>
    // return <Authenticator />
  }

  // if (emailVerifReq) {
  //   return <VerifyEmail setEmailVerifReq={setEmailVerifReq} phone/>;
  // }

  if (!(user && user.config)) {
    return (
      <UserData.Provider value={user}>
      <CurrentState.Provider value={currentState}>
      <Router>
        <Route path='/'
          render={props => (
            <LoadingScreen/>
          )}
        />
      </Router>
      </CurrentState.Provider>
    </UserData.Provider>
    )
  }

  async function setDisclaimer(disclaimerAgreeValue, disclaimerDontShowAgain) {
    try {
      const disclaimerAgree = disclaimerAgreeValue ? disclaimerVersion : false
      const progressApi = Progress.getInstance();
      await progressApi.store({disclaimerAgree, disclaimerDontShowAgain: disclaimerDontShowAgain ? 'true' : 'false'})
      if (disclaimerAgree) {
        setShowDisclaimer(false)
      }
    }
    catch (err) {
      console.error(`setDisclaimer ${err.message}`)
    }
  }

  if (showDisclaimer) {
    return (
      <UserData.Provider value={user}>
      <CurrentState.Provider value={currentState}>
      <Router>
        <Route path='/'
          render={props => (
            <DisclaimerScreen
            submit={setDisclaimer}/>
          )}
        />
      </Router>
      </CurrentState.Provider>
    </UserData.Provider>
    )
  }

  return (
    <UserData.Provider value={user}>
      <CurrentState.Provider value={currentState}>
      <Router>
        <Route exact path='/'
          render={props => (
            <SearchScreen {...props}
              updateCurrentState={updateCurrentState}
              updateSearchString={updateSearchString}
              searchString={searchString}
      />
          )}
        />
        <Route exact path='/'>
          <Redirect to={currentState.initialURL}/>
        </Route>
        <Route path='/display/:companyId' component={DisplayScreen}/>
        <Route path='/recent-messages' component={PortalRecentMessageScreen} />
        {/* <Route path='/interests' component={InterestsScreen}/> */}
        <Route path='/interests'
          render={props => (
            <InterestsScreen {...props}
            resetInitialURL={resetInitialURL}/>
          )}
        />

        <Route path='/admin' component={AdminScreen}/>
      </Router>
      </CurrentState.Provider>
    </UserData.Provider>
  );
};

// export default withAuthenticator(App, false, [], null, theme);
export default App;
